import { useSegmentV1ControllerCreate } from 'generated/apiComponents';

export const useCreateSegmentMutation = () => {
  const { mutateAsync, isPending } = useSegmentV1ControllerCreate();

  return { createSegment: mutateAsync, isLoading: isPending };
};
